import { defineNuxtPlugin } from 'nuxt/app'
import VCalendar from '@angelblanco/v-calendar'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(VCalendar)
})
